<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Hey, <br/>
    We'll have to deal with a media storm when we go public about the start date of the tower construction. Let's align tomorrow on our media strategy - please schedule something for us, Anand. Thanks.<br/><br/>

    Chris Bond<br/>
    CEO<br/><br/>

    Assistant: Laura Anderson, l.anderson@atcl.com
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
